module.exports = __webpack_public_path__ + "img/cc.1abca6d2.svg";